import FormPeticiones from '../components/FormPeticiones.vue'
import ListaPeticiones from '../components/ListaPeticiones.vue'
const routes = [
    ...route('/guardar-peticion', FormPeticiones, {
        Auth: true,
        ///req_admin: true
     }),
     ...route('/lista-peticiones', ListaPeticiones, {
       Auth: true,
       //req_admin: true
    }),
]

function route(path, component = Default, meta = {}) {
	return [{
		path,
		component,
		meta
	}]
}

export default routes